import { PaginationTable } from '../../../common';

const LegalEntitiesPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <PaginationTable
      totalPages={totalPages}
      totalCount={totalCount}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
    />
  );
};

export default LegalEntitiesPagination;
